import React, { useEffect } from "react";
import { track, ANALYTICS_EVENTS } from "../../utils/productAnalytics";
import LPHeader from "./components/LPHeader";
import HeroSection from "./sections/HeroSection";
import FeaturesSection from "./sections/FeaturesSection";
import BannerGallerySection from "./sections/BannerGallerySection";
import HowItWorksSection from "./sections/HowItWorksSection";
import PricingSection from "./sections/PricingSection";
import FAQSection from "./sections/FAQSection";
import FinalCTASection from "./sections/FinalCTASection";
import LPFooter from "./components/LPFooter";
import "../../styles/lp-variables.css";

const LandingPage: React.FC = () => {
  useEffect(() => {
    track(ANALYTICS_EVENTS.LP_VIEWED);
  }, []);

  return (
    <div className="landing-page min-h-screen">
      <LPHeader />
      <main>
        <HeroSection />
        <FeaturesSection />
        <BannerGallerySection />
        <HowItWorksSection />
        <PricingSection />
        <FAQSection />
        <FinalCTASection />
      </main>
      <LPFooter />
    </div>
  );
};

export default LandingPage;
